import React from "react";
import {
  LineChart,
  Line,
  YAxis,
  ResponsiveContainer,
  ReferenceLine,
  ReferenceArea,
} from "recharts";

export const ReportIndicatorChart = ({ referenceLineCoordinates, values }) => {
  const data = values.map((v, i) => ({ name: i.toString(), pv: v }));

  const areaCoords = [
    +referenceLineCoordinates[0].toFixed(1),
    +referenceLineCoordinates[1].toFixed(1),
  ];

  const padding = (areaCoords[1] - areaCoords[0]) * 0.5;
  const yDomain = [
    +(areaCoords[0] - padding).toFixed(1),
    +(areaCoords[1] + padding).toFixed(1),
  ];

  const refMid = (areaCoords[0] + areaCoords[1]) / 2;
  const refRange = (areaCoords[1] - areaCoords[0]) * 0.2;

  const renderCustomDot = ({ cx, cy, value }) => {
    let fill = "#FDB022"; // red
    if (value > areaCoords[0] && value < areaCoords[1]) fill = "#12B76A";

    return <circle cx={cx} cy={cy} r={3} fill={fill} stroke="none" />;
  };

  return (
    <div style={{ fontFamily: "Manrope" }}>
      <ResponsiveContainer width={130} height={75}>
        <LineChart
          data={data}
          margin={{ top: 5, right: 5, left: 5, bottom: 5 }}
        >
          <YAxis
            domain={yDomain}
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 8, fontFamily: "monospace" }}
            width={30}
            unit="°"
          />
          <ReferenceArea
            y1={areaCoords[0]}
            y2={areaCoords[1]}
            fill="#12B76A"
            fillOpacity={0.1}
          />
          <ReferenceLine y={areaCoords[0]} stroke="#12B76A" strokeWidth={1} />
          <ReferenceLine y={areaCoords[1]} stroke="#12B76A" strokeWidth={1} />

          <Line
            type="linear"
            dataKey="pv"
            stroke="#98A2B3"
            strokeDasharray="2 2"
            strokeWidth={1}
            dot={renderCustomDot}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
